import { Controller } from "@hotwired/stimulus"
import Cookies from "js-cookie"

export default class extends Controller {
  static values = {
    postId: Number,
    apiUrl: String
  }

  connect() {
    const cookieKey = `sc-post-read-${this.postIdValue}`
    if (Cookies.get(cookieKey)) {
      this.updateButtonUI()
    }
  }

  click(event) {
    event.preventDefault()

    const cookieKey = `sc-post-read-${this.postIdValue}`
    if (Cookies.get(cookieKey)) return

    const data = new URLSearchParams()
    data.append("id", this.postIdValue)

    fetch(`${this.apiUrlValue}/like`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data
    })
    .then(response => response.json())
    .then(data => {
      if (data.id) {
        this.updateButtonUI()
        Cookies.set(cookieKey, "true", { expires: 365 })
      }
    })
    .catch(console.error)
  }

  updateButtonUI() {
    this.element.classList.add("disabled")
    const icon = this.element.querySelector("i")
    icon.classList.remove("bi-hand-thumbs-up-fill")
    icon.classList.add("bi-check-lg", "text-primary")
  }
}
